import { render } from "./VAside.vue?vue&type=template&id=e4b27d20"
import script from "./VAside.vue?vue&type=script&lang=js"
export * from "./VAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__